var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBestSellerFirst = function SvgBestSellerFirst(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 45,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#BestSellerFirst_svg__a)",
    d: "M0 3.5A3.5 3.5 0 0 1 3.5 0h29A3.5 3.5 0 0 1 36 3.5v38.74a1.75 1.75 0 0 1-2.497 1.582L0 28.02z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#BestSellerFirst_svg__b)",
    d: "M0 3.5A3.5 3.5 0 0 1 3.5 0h29A3.5 3.5 0 0 1 36 3.5v24.519L2.497 43.822A1.75 1.75 0 0 1 0 42.24z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.42 13.064v-1.658q2.685-.393 3.73-2.706h1.92v16.8h-2.64V14.133q.001-.61-.064-.83-.066-.24-.415-.24z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "BestSellerFirst_svg__a",
    x1: 22.875,
    x2: 31.479,
    y1: 30.991,
    y2: 45.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCA642"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4CB67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BestSellerFirst_svg__b",
    x1: 7.875,
    x2: 26.056,
    y1: 0,
    y2: 35.178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.089,
    stopColor: "#FDEEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    stopColor: "#F4CC67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769,
    stopColor: "#F1C24C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE49C"
  })))));
};
export default SvgBestSellerFirst;